const User = {
    namespaced: true,
    state: {
        profile: null,
    },
    getters: {
        getProfile: (state) => {
            return state.profile;
        },
    },
    mutations: {
        SET_PROFILE(state, profile) {
            state.profile = profile;
        },
        SET_USER_EMAIL(state, email) {
            _.set(state.profile, 'has_email', !!email);
        },
    },
    actions: {
        login({ commit }, profile) {
            commit('SET_PROFILE', profile);
        },
        setEmail({ commit }, email) {
            commit('SET_USER_EMAIL', email);
        },
        logout({ commit }) {
            commit('SET_PROFILE', null);
        },
    },
};

export default User;
